module.exports = __webpack_public_path__ + "static/media/logo-laser.6d1b7fe3.svg";